import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaLayoutFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutFields';

const styles = () => ({
  root: {},
});

/**
 * @deprecated
 *
 * Use UI component MetaLayoutVertical instead.
 */
const MetaFormFields = ({
  className,
  classes,
  resource,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaLayoutFields resource={resource} />
    </Box>
  );
};

MetaFormFields.defaultProps = {
  className: '',
};

MetaFormFields.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(MetaFormFields);
